module.exports = __webpack_public_path__ + "img/pin-hyf.0d605170.svg";